module.exports = __webpack_public_path__ + "img/wb_ph.8815f96c.jpg";